// 수신자료관리 - 모듈단가자료조회
import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const RNTM1 = lazy(() => import('@/pages/B04/RNTM1'));  // 모듈BOM
const RNTC1 = lazy(() => import('@/pages/B04/RNTC1'));  // 모듈 단가현황
const RNTC2 = lazy(() => import('@/pages/B04/RNTC2'));  // 모듈 단가상세내역
const RNTC3 = lazy(() => import('@/pages/B04/RNTC3'));  // 모듈 단가상세내역
const RNTC4 = lazy(() => import('@/pages/B04/RNTC4'));  // 사양차이 정산 상세내역
const RNTC5 = lazy(() => import('@/pages/B04/RNTC5'));  // 단가차이 정산 상세내역
const RNTC6 = lazy(() => import('@/pages/B04/RNTC6'));  // ZERO단가 조건 정산 상세내역
const RNTC7 = lazy(() => import('@/pages/B04/RNTC7'));  // 정단가 조건 정산 상세내역

function B04() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/B04/RNTM1" component={RNTM1} />
        <Route path="/B04/RNTC1" component={RNTC1} />
        <Route path="/B04/RNTC2" component={RNTC2} />
        <Route path="/B04/RNTC3" component={RNTC3} />
        <Route path="/B04/RNTC4" component={RNTC4} />
        <Route path="/B04/RNTC5" component={RNTC5} />
        <Route path="/B04/RNTC6" component={RNTC6} />
        <Route path="/B04/RNTC7" component={RNTC7} />
      </Switch>
    </Suspense>
  );
}

export default B04;
